import { useEffect } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Outlet, useParams } from "react-router";
import { ResearchId } from "../../adapters/insights-agent/state/AppState.ts";
import { useAppName } from "../../adapters/insights-agent/state/hooks/useAppName.ts";
import { useInsightsAgentService } from "../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { useConfig } from "../../adapters/insights-agent/state/hooks/useConfig.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { ConnectedHistorySidebar } from "./connected-components/ConnectedHistorySidebar.tsx";
import { ConnectedReferencesSidebar } from "./connected-components/ConnectedReferencesSidebar.tsx";
import { Header } from "../../feature-components/Header/Header.tsx";
import styles from "./WorkflowLayout.module.css";

export const InsightsAgentLayout = () => {
  const appService = useInsightsAgentService();
  const { environment } = useConfig();
  const enableGlobalNav = useFeatureFlagValue("enableGlobalNav");
  useEffect(() => {
    appService.refreshResearches().then();
  }, [appService]);
  const { id } = useParams();
  return (
    <div className={styles.WorkflowLayout}>
      <Header
        isAuthenticated
        enableGlobalNav={enableGlobalNav}
        onLogoutClick={appService.authService.logout}
        env={environment}
        appTitle={useAppName()}
      />
      <div className={styles.WorkflowGrid}>
        <PanelGroup direction="horizontal" autoSaveId="workflow-layout">
          <Panel minSize={10} defaultSize={13}>
            <ConnectedHistorySidebar />
          </Panel>
          <PanelResizeHandle className={styles.ResizeHandle} />
          <Panel minSize={50} defaultSize={50}>
            <Outlet />
          </Panel>
          {id && id !== "new" && (
            <>
              <PanelResizeHandle className={styles.ResizeHandle} />
              <Panel minSize={30} defaultSize={37}>
                <ConnectedReferencesSidebar researchId={id as ResearchId} />
              </Panel>
            </>
          )}
        </PanelGroup>
      </div>
    </div>
  );
};
